import React, { Component, useState } from 'react';
import { string, bool, node, object } from 'prop-types';
import Switch from '../atoms/Switch';

const CollapsibleWithSwitch = ({ title, description, children, hasSwitch, switchName, toggleLabel, formHook, initialValues = {} }) => {

  const { register, getValues } = formHook;

  const [isExpanded, setIsExpanded] = useState(false);
  const [height, setHeight] = useState(0);
  const [currentHeight, setCurrentHeight] = useState(0);

  let maskedContent = null;

  const setMaskedContentRef = (maskedContentRef) => {
    maskedContent = maskedContentRef;
  };

  const handleCollapse = () => {
    setIsExpanded(!isExpanded);
    setHeight(maskedContent.clientHeight);
  };

  return (
    <div className={`panel ${isExpanded ? 'is-expanded' : ''}`}>
      <div className="panel__heading">
        <div className="row between middle">
          <h2 className="title-xl nobullet">{title}</h2>
          {hasSwitch && (
            <span>
              <Switch
                name={switchName}
                ref={register()}
                defaultValue={initialValues[switchName]}
              />
            </span>
          )}
        </div>
        <hr className="mt-half" />
      </div>
      <div className="panel__collapse">
        <div>{description}</div>
        <button className="link mv-half" onClick={handleCollapse} type="button">
          {toggleLabel} <i className={`icon icon-chevron-${isExpanded ? 'up' : 'down'} icon--thick`} />
        </button>
        <div className="panel__masked-content" style={{ height: `${isExpanded ? height : 0}px` }}>
          <div ref={setMaskedContentRef}>{children}</div>
        </div>
      </div>
    </div>
  );
};

CollapsibleWithSwitch.propTypes = {
  title: string,
  description: string,
  children: node,
  hasSwitch: bool,
  switchName: string,
  toggleLabel: string,
  formHook: object,
  initialValues: object
};

export default CollapsibleWithSwitch;
